import React from "react";
import { Container, Row, Col, Button, Accordion } from "react-bootstrap";
import Slider from "react-slick";
// import "./PackageDetail.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const NextArrow = ({ onClick }) => (
  <div className="slider-arrow next" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slider-arrow prev" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const ManokamnaPackage = () => {

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className="package-detail">

      {/* HERO BANNER */}
      <div
        className="package-hero-banner"
        style={{
          backgroundImage:
            "url('/Images/tour/manokamna-banner.jpeg')",
        }}
      >
        <Container>
          <div className="hero-content">
            <h1>Manokamna Devi Darshan Tour</h1>

            <p className="hero-subtitle">
              2 Nights / 3 Days • Sacred Manokamna Temple Visit
            </p>

            <div className="hero-price">
              Starting From <span>₹16,999</span> / Per Person
            </div>
          </div>
        </Container>
      </div>

      <Container className="package-container">

        {/* SLIDER + FORM */}
        <Row className="mb-4">

          {/* LEFT SLIDER */}
          <Col lg={8}>
            <div className="package-slider">
              <Slider {...sliderSettings}>
                <img src="/Images/tour/manokamna-banner.jpeg" alt="" />
                <img src="/Images/tour/manokamna1.jpg" alt="" />
                <img src="/Images/tour/manokamna2.jpeg" alt="" />
              </Slider>
            </div>
          </Col>

          {/* RIGHT ENQUIRY FORM */}
          <Col lg={4}>
            <div className="enquiry-sidebar">
              <h2>₹16,999</h2>
              <p>Per Person</p>

              <Button variant="danger" className="mb-3">
                Book Now
              </Button>

              <form>
                <input type="text" placeholder="Your Name" />
                <input type="text" placeholder="Mobile Number" />
                <input type="date" />
                <input type="number" placeholder="Persons" />
                <textarea placeholder="Message"></textarea>

                <Button variant="dark">Send Enquiry</Button>
              </form>
            </div>
          </Col>
        </Row>

        {/* MAIN CONTENT */}
        <Row>
          <Col lg={8}>

            <div className="package-header">
              <h1>Manokamna Devi Darshan Tour</h1>
              <p>2 Nights / 3 Days • Religious Pilgrimage Package</p>
            </div>

            {/* Highlights */}
            <div className="content-box highlight-box">
              <h3>Tour Highlights</h3>

              <Row>
                <Col md={6}>✔ Manokamna Devi Temple Darshan</Col>
                <Col md={6}>✔ Scenic Cable Car Ride</Col>
                <Col md={6}>✔ Trishuli River Views</Col>
                <Col md={6}>✔ Spiritual Himalayan Experience</Col>
              </Row>
            </div>

            {/* Overview */}
            <div className="content-box">
              <h3>Overview</h3>
              <p>
                Visit the sacred Manokamna Devi Temple, believed to fulfill
                devotees' wishes. Enjoy breathtaking mountain views,
                thrilling cable car rides and divine spiritual atmosphere
                in Nepal.
              </p>
            </div>

            {/* Itinerary */}
            <div className="content-box">
              <h3>Day Wise Itinerary</h3>

              <Accordion defaultActiveKey="0">

                <Accordion.Item eventKey="0">
                  <Accordion.Header>Day 1 – Arrival Kathmandu</Accordion.Header>
                  <Accordion.Body>
                    Arrival at Kathmandu and transfer to hotel. Evening free
                    for leisure or temple visits.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Day 2 – Manokamna Temple Darshan
                  </Accordion.Header>
                  <Accordion.Body>
                    Drive to Kurintar and take cable car ride to Manokamna
                    Temple for divine darshan and blessings.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>Day 3 – Departure</Accordion.Header>
                  <Accordion.Body>
                    Breakfast and transfer for onward journey with spiritual
                    memories.
                  </Accordion.Body>
                </Accordion.Item>

              </Accordion>
            </div>

            {/* Inclusion / Exclusion */}
            <div className="content-box">
              <Row>

                <Col md={6}>
                  <h4>Inclusions</h4>
                  <ul className="inclusion-list">
                    <li>Hotel Accommodation</li>
                    <li>Daily Breakfast</li>
                    <li>Cable Car Tickets</li>
                    <li>Transfers & Sightseeing</li>
                  </ul>
                </Col>

                <Col md={6}>
                  <h4>Exclusions</h4>
                  <ul className="exclusion-list">
                    <li>Personal Expenses</li>
                    <li>Travel Insurance</li>
                    <li>Lunch & Dinner</li>
                    <li>Puja Special Charges</li>
                  </ul>
                </Col>

              </Row>
            </div>

            {/* Gallery */}
            <div className="content-box">
              <h3>Gallery</h3>

              <Row className="gallery">
                <Col md={4}>
                  <img src="/Images/tour/manokamna-banner.jpeg" alt="" />
                </Col>
                <Col md={4}>
                  <img src="/Images/tour/manokamna1.jpg" alt="" />
                </Col>
                <Col md={4}>
                  <img src="/Images/tour/manokamna2.jpeg" alt="" />
                </Col>
              </Row>
            </div>

          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default ManokamnaPackage;